/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import { Box, Button } from '@chakra-ui/react';
import { ChartBar } from 'phosphor-react';
import { useParams } from 'react-router-dom';
import { ErrorState } from '../../../components/states';
import { DataGrid } from '../../../components/datagrid';
import { SearchFilter } from '../../../components/inputs/filters/search';
import { PageTitle } from '../../../components/PageTitle';
import { useFetch } from '../../../hooks/useFetch';
import { getCellStatus } from '../../../utils/FormatFunctions';
import Loader from '../../../components/Loader';
import { useAuth } from '../../../providers/auth';
import { usePageTracking } from '../../../hooks/usePageTracking';
import { AnalyticsModal } from '../../../components/analytics';
import { PageAction } from '../../../components/ui';

export function WeeksMeetingsPage() {
  const { moduleId, weekId } = useParams();
  usePageTracking(`week_${weekId}_meetings`);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/contents?week_id=${weekId}`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);
  const { user } = useAuth();

  const {
    requestApi: reqApiWeek,
    data: dataWeek,
    loading: loadingWeek,
    error: errorWeek,
  } = useFetch('/v1/admin/weeks');

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Nome' },
    { name: 'title', label: 'Título' },
    { name: 'status', label: 'Status' },
  ];

  useEffect(() => {
    reqApiWeek('get', null, `/v1/admin/weeks/${weekId}`);
  }, [weekId]);

  if (loadingWeek) {
    return <Loader />;
  }

  if (errorWeek) {
    return <ErrorState onRetry={() => reqApiWeek('get', null, `/v1/admin/weeks/${weekId}`)} />;
  }
  const groupIds = user?.group?.id;
  const hasAnalyticsAccess = [1, 2, 3, 6, 7].includes(groupIds || 0);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <Box>
      <PageTitle
        description="Encontros programados para esta semana."
        backTo={`/contents/modules/${moduleId}/weeks`}
        backLabel="Semanas"
        currentLabel={dataWeek?.data?.name ?? 'Encontros'}
      >
        {dataWeek?.data?.name ?? 'Encontros'}
      </PageTitle>
      {hasAnalyticsAccess && (
        <PageAction>
          <Button
            variant="outline"
            leftIcon={<ChartBar size={14} />}
            aria-label="Estatísticas"
            onClick={handleOpenModal}
          >
            Estatísticas da semana
          </Button>
        </PageAction>
      )}

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate={groupIds !== 7 && groupIds !== 3}
        loading={loading}
        rowActions={{
          show: true,
          edit: groupIds !== 7 && groupIds !== 3 && groupIds !== 6,
          delete: groupIds !== 7 && groupIds !== 6 && groupIds !== 3,
        }}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
      />

      {/* Modal de Estatísticas - Mostra dados da semana */}
      <AnalyticsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        weekId={parseInt(weekId || '0', 10)}
        type="week"
      />
    </Box>
  );
}
